// eslint-disable-next-line no-restricted-imports
import {
  ActivityDto_Input,
  Query_LegalClientController_GetList_AllOf_1_List_Items_Activity_Activity,
} from 'api/generated/graphql';
import { LegalClientActivityParam } from 'api/types/params';

export const parseLegalClientActivityParam = (
  data: LegalClientActivityParam
): ActivityDto_Input => ({
  activity:
    Query_LegalClientController_GetList_AllOf_1_List_Items_Activity_Activity[
      data.activity
    ],
  isLargeEnterprise: data.isLargeEnterprise,
  isNominalHolder: data.isNominalHolder,
  isSubAccountRequiredForNominalHolding: data.requiresNominalHoldingSubaccount,
  otherActivity: data.otherActivity,
});
